@if ((stageItems.early | keyvalue).length > 0) {
    <div class="gray-box">
        <h6 class="fw-bold">Early Stage</h6>

        @for (week of stageItems.early | keyvalue; track week.key) {
            <div class="week-box">
                <h6><b>Week {{ +week.key }}</b></h6>
                <ul>
                    @for (item of week.value; track $index) {
                        <li>
                            Chapter {{ $index + 1}} - {{ item.title }}
                        </li>
                    }
                </ul>
            </div>
        }
    </div>
}

@if ((stageItems.mid | keyvalue).length > 0) {
    <div class="gray-box">
        <h6 class="fw-bold">Mid Stage</h6>

        @for (week of stageItems.mid | keyvalue; track week.key) {
            <div class="week-box">
                <h6><b>Week {{ +week.key }}</b></h6>
                <ul>
                    @for (item of week.value; track $index) {
                        <li>
                            Chapter {{ $index + 1}} - {{ item.title }}
                        </li>
                    }
                </ul>
            </div>
        }
    </div>
}

@if ((stageItems.late | keyvalue).length > 0) {
    <div class="gray-box">
        <h6 class="fw-bold">Late Stage</h6>

        @for (week of stageItems.late | keyvalue; track week.key) {
            <div class="week-box">
                <h6><b>Week {{ +week.key }}</b></h6>
                <ul>
                    @for (item of week.value; track $index) {
                        <li>
                            Chapter {{ $index + 1}} - {{ item.title }}
                        </li>
                    }
                </ul>
            </div>
        }
    </div>
}
